'use client';

import {createTheme, Theme} from '@mui/material/styles';

const theme: Theme = createTheme({
    typography: {
        fontFamily: 'var(--font-stack)',
        button: {
            fontFamily: 'var(--font-headline)',
            textTransform: 'none',
        },
    },
});

export default theme;
